
import Vue from 'vue'
import Vuex from 'vuex'
// import * as api1an from '@/api/insurance/1an/api'

Vue.use(Vuex)

const state = {
    person:{
        page1InitInfo:{
            showAreaChoose:false,//显示区域选择
            areaInfo:null,
            areaName:'',
            pickStartDate:new Date(),
            insAmount:"",//财产险保额
            insBroken:false,
            insThree:false,
            insRobbery:false,
            isCoastal:'notChoose',
            insThreeAmt:'50000',
        },
        page2InitInfo:{
            showAddSNPannel:false,
            inverterLists : {seq:0,nums:'',list:[{value:'',index:0}]},
            pickStartDate:new Date(),
            pickEndDate:new Date(),
            invoceTypeList:[
				{"invoiceTypeCode": null,"invoiceTypeName": null},
				{"invoiceTypeCode": "026","invoiceTypeName": "电子普票"},
				{"invoiceTypeCode": "007","invoiceTypeName": "纸质普票"},
                {"invoiceTypeCode": "004","invoiceTypeName": "纸质专票"},],
            policyholderTypeShow:false,//投保人类型:
            policyholderTypeSlots: [{values: [{applyTypeCode:'P',code:'1',name:'个人'},{applyTypeCode:'B',code:'2',name:'企业'}],textAlign: 'center'}],
			policyholderTypeValue:null,
			personIdTypeShow:false,//个人证件类型
			personIdTypeSlots:[{values: [],textAlign: 'center'}],
			personIdTypeValue:null,
			isSelfShow:false,
			isSelfSlots: [{values: [{code:'1',name:'否'},{code:'2',name:'是'}],textAlign: 'center'}],
			isSelfValue:[],
			isSelf:"否",
			closeOnClickModal:false,
        },
        order:{
            "connectGridDate": null,
            "invoiceTypeCode": null,
            "invoiceTypeName": null,
            "platform": 2,//H5 保险
            "roofTypeName":null,
            "premium": '',
            "provinceId": 0,
            "cityId": 0,
            "districtId": 0,
            "deviceCost": null,
            "startDate": null,
            "endDate": null,
            "inverterNumber": null,
            "installedCapacity": null,
            "powerStationAddress": "",
            "moduleBrandCode": null,
            "inverterBrandCode": null
        },
        orderInsuranceTypeRelList:null,
        imageList:[{"path": null,"type": 1},{"path": null,"type": 2}],
        invoice:{
            "applyTypeCode":"P",
            "applyTypeName":"个人",
            "TypeCode":null,
            "TypeName":null,
            "title": null,
            "type": 0,
            "email": null,
            "companyPhone":"",
            "receiverName": null,
            "receiverTelephone": null,
            "receiverAddress": null,
            "regAddress": null,
            "taxNumber": null,
            "bankCode": null,
            "bankAccount": null
        },
        insurantInfo:{//被保险人信息
            "relationTypeCode": 2,//1:投保人2:被保险人
            "relationTypeName":'被保险人',
            "idTypeCode":'01',//证件类型（企业直接用纳税识别号）
            "idTypeName":"居民身份证",
            "relatePersonTypeCode": '1',//关系人类型 1:个人，2：企业
            "relatePersonTypeName":"个人",
            "name": null,
            "idNumber": null,
            "email":null,
            "telephone": null,
            "companyAddress": null,
            "companyContact": null,
            "companyContactTelephone": null,
            "companyOfficephone": null
        },
        policyholder:{//投保人信息
            "relationTypeCode": 1,//1:投保人2:被保险人
            "relationTypeName":'投保人',
            "relatePersonTypeCode": '1',//关系人类型 1:个人，2：企业
            "relatePersonTypeName":"个人",
            "idTypeCode": null,
            "name": null,
            "email":null,
            "idNumber": null,
            "telephone": null,
            "companyAddress": null,
            "companyContact": null,
            "companyContactTelephone": null,
            "companyOfficephone": null
        }
    },
    company:{
        page1InitInfo:{
            showAreaChoose:false,//显示区域选择
            areaInfo:null,
            areaName:'',
            pickStartDate:new Date(),
            insAmount:"",//财产险保额
            insBroken:false,
            insThree:false,
            insRobbery:false,
            isCoastal:'notChoose',
            insThreeAmt:'50000',
        },
        page2InitInfo:{
            showAddSNPannel:false,
            inverterLists : {seq:0,nums:'',list:[{value:'',index:0}]},
            pickStartDate:new Date(),
            pickEndDate:new Date(),
            invoceTypeList:[
				{"invoiceTypeCode": null,"invoiceTypeName": null},
				{"invoiceTypeCode": "026","invoiceTypeName": "电子普票"},
				{"invoiceTypeCode": "007","invoiceTypeName": "纸质普票"},
                {"invoiceTypeCode": "004","invoiceTypeName": "纸质专票"},],
			personIdTypeShow:false,//证件类型
			personIdTypeSlots:[{values: [],textAlign: 'center'}],
			personIdTypeValue:null,
			closeOnClickModal:false,
        },
        order:{
            "connectGridDate": null,
            "invoiceTypeCode": null,
            "invoiceTypeName": null,
            "platform": 2,//H5 保险
            "roofTypeName":null,
            "premium": '',
            "provinceId": 0,
            "cityId": 0,
            "districtId": 0,
            "deviceCost": null,
            "startDate": null,
            "endDate": null,
            "inverterNumber": null,
            "installedCapacity": null,
            "powerStationAddress": "",
            "moduleBrandCode": null,
            "inverterBrandCode": null
        },
        orderInsuranceTypeRelList:null,
        imageList:[{"path": null,"type": 1},{"path": null,"type": 2}],
        invoice:{
            "applyTypeCode":"B",
			"applyTypeName":"企业",
            "TypeCode":null,
            "TypeName":null,
            "title": null,
            "type": 0,
            "email": null,
            "companyPhone":"",
            "receiverName": null,
            "receiverTelephone": null,
            "receiverAddress": null,
            "regAddress": null,
            "taxNumber": null,
            "bankCode": null,
            "bankAccount": null
        },
        insurantInfo:{//被保险人信息
            "relationTypeCode": 2,//1:投保人2:被保险人
            "relationTypeName":'被保险人',
            "idTypeCode":null,//证件类型（企业直接用纳税识别号）
            "idTypeName":null,
            "relatePersonTypeCode": '2',//关系人类型 1:个人，2：企业
            "relatePersonTypeName":"企业",
            "name": null,
            "idNumber": null,
            "email":null,
            "telephone": null,
            "companyAddress": null,
            "companyContact": null,
            "companyContactTelephone": null,
            "companyOfficephone": null
        },
        policyholder:{//投保人信息
            "relationTypeCode": 1,//1:投保人2:被保险人
			"relationTypeName":'投保人',
			"relatePersonTypeCode": 2,//关系人类型 1:个人，2：企业
			"relatePersonTypeName":"企业",
			"idTypeCode": "14",
			"idTypeName": "统一社会信用代码",
            "name": null,
            "email":null,
            "idNumber": null,
            "telephone": null,
            "companyAddress": null,
            "companyContact": null,
            "companyContactTelephone": null,
            "companyOfficephone": null
        }
    },
    highprice:{
        page1InitInfo:{
            showAreaChoose:false,//显示区域选择
            areaInfo:null,
            areaName:'',
            pickStartDate:new Date(),
            insAmount:"",//财产险保额
            insBroken:false,
            insThree:false,
            insRobbery:false,
            isCoastal:'notChoose',
            insThreeAmt:'1000000',
        },
        page2InitInfo:{
            showAddSNPannel:false,
            inverterLists : {seq:0,nums:'',list:[{value:'',index:0}]},
            pickStartDate:new Date(),
            pickEndDate:new Date(),
            invoceTypeList:[
				{"invoiceTypeCode": null,"invoiceTypeName": null},
				{"invoiceTypeCode": "026","invoiceTypeName": "电子普票"},
				{"invoiceTypeCode": "007","invoiceTypeName": "纸质普票"},
                {"invoiceTypeCode": "004","invoiceTypeName": "纸质专票"},],
			personIdTypeShow:false,//证件类型
			personIdTypeSlots:[{values: [],textAlign: 'center'}],
            personIdTypeValue:null,
            roofTypeShow:false,//屋顶类型
			roofTypeSlots:[{values: [],textAlign: 'center'}],
            roofTypeValue:null,
			closeOnClickModal:false,
        },
        order:{
            "connectGridDate": null,
            "invoiceTypeCode": null,
            "invoiceTypeName": null,
            "platform": 2,//H5 保险
            "roofTypeCode":null,
            "roofTypeName":null,
            "premium": '',
            "provinceId": 0,
            "cityId": 0,
            "districtId": 0,
            "deviceCost": null,
            "startDate": null,
            "endDate": null,
            "inverterNumber": null,
            "installedCapacity": null,
            "powerStationAddress": "",
            "moduleBrandCode": null,
            "inverterBrandCode": null
        },
        orderInsuranceTypeRelList:null,
        imageList:[{"path": null,"type": 1},{"path": null,"type": 2},{"path": null,"type": 3}],
        invoice:{
            "applyTypeCode":"B",
			"applyTypeName":"企业",
            "TypeCode":null,
            "TypeName":null,
            "title": null,
            "type": 0,
            "email": null,
            "companyPhone":"",
            "receiverName": null,
            "receiverTelephone": null,
            "receiverAddress": null,
            "regAddress": null,
            "taxNumber": null,
            "bankCode": null,
            "bankAccount": null
        },
        insurantInfo:{//被保险人信息
            "relationTypeCode": 2,//1:投保人2:被保险人
            "relationTypeName":'被保险人',
            "idTypeCode":null,//证件类型（企业直接用纳税识别号）
            "idTypeName":null,
            "relatePersonTypeCode": '2',//关系人类型 1:个人，2：企业
            "relatePersonTypeName":"企业",
            "name": null,
            "idNumber": null,
            "email":null,
            "telephone": null,
            "companyAddress": null,
            "companyContact": null,
            "companyContactTelephone": null,
            "companyOfficephone": null
        },
        policyholder:{//投保人信息
            "relationTypeCode": 1,//1:投保人2:被保险人
			"relationTypeName":'投保人',
			"relatePersonTypeCode": 2,//关系人类型 1:个人，2：企业
			"relatePersonTypeName":"企业",
			"idTypeCode": "14",
            "idTypeName": "统一社会信用代码",
            "name": null,
            "email":null,
            "idNumber": null,
            "telephone": null,
            "companyAddress": null,
            "companyContact": null,
            "companyContactTelephone": null,
            "companyOfficephone": null
        }
    }
}

const mutations = {
    SET_PERSON_STEP1 : (state, payload)=>{
        state.person.page1InitInfo = payload.page1InitInfo;
        state.person.order = payload.order;
        state.person.orderInsuranceTypeRelList = payload.orderInsuranceTypeRelList;
    },
    SET_PERSON_STEP2 : (state, payload)=>{
        state.person.page2InitInfo = payload.page2InitInfo;
        state.person.order = payload.order;
        state.person.insurantInfo = payload.insurantInfo;
        state.person.policyholder = payload.policyholder;
        state.person.imageList = payload.imageList;
        state.person.invoice = payload.invoice;
    },
    SET_COMPANY_STEP1 : (state, payload)=>{
        state.company.page1InitInfo = payload.page1InitInfo;
        state.company.order = payload.order;
        state.company.orderInsuranceTypeRelList = payload.orderInsuranceTypeRelList;
    },
    SET_COMPANY_STEP2 : (state, payload)=>{
        state.company.page2InitInfo = payload.page2InitInfo;
        state.company.order = payload.order;
        state.company.insurantInfo = payload.insurantInfo;
        state.company.policyholder = payload.policyholder;
        state.company.imageList = payload.imageList;
        state.company.invoice = payload.invoice;
    },
    SET_HIGHPRICE_STEP1 : (state, payload)=>{
        state.highprice.page1InitInfo = payload.page1InitInfo;
        state.highprice.order = payload.order;
        state.highprice.orderInsuranceTypeRelList = payload.orderInsuranceTypeRelList;
    },
    SET_HIGHPRICE_STEP2 : (state, payload)=>{
        state.highprice.page2InitInfo = payload.page2InitInfo;
        state.highprice.order = payload.order;
        state.highprice.insurantInfo = payload.insurantInfo;
        state.highprice.policyholder = payload.policyholder;
        state.highprice.imageList = payload.imageList;
        state.highprice.invoice = payload.invoice;
    }
}

const getters = {
    personInsurance: state => state.person,
    companyInsurance: state => state.company,
    highpriceInsurance: state => state.highprice
}

const actions = {
    setPersonStep1({commit},data){
        commit('SET_PERSON_STEP1',data)
    },
    setPersonStep2({commit},data){
        commit('SET_PERSON_STEP2',data)
    },
    setCompanyStep1({commit},data){
        commit('SET_COMPANY_STEP1',data)
    },
    setCompanyStep2({commit},data){
        commit('SET_COMPANY_STEP2',data)
    },
    setHighpriceStep1({commit},data){
        commit('SET_HIGHPRICE_STEP1',data)
    },
    setHighpriceStep2({commit},data){
        commit('SET_HIGHPRICE_STEP2',data)
    },
}

export default new Vuex.Store({
    namespaced: true,
    state,
    getters,
    mutations,
    actions
})



// WEBPACK FOOTER //
// ./src/store/insurance/1an/index.js